.dialog {
  width: min(600px, calc(100vw - 2 * var(--s-6)));
  max-height: calc(100dvh - 2 * var(--s-6));
  margin: min(16vh, 120px) auto auto;
  padding: 0;
  border: none;
  overflow: visible;
  background: transparent;
  color: var(--text-body);
}
.dialog::backdrop {
  background: var(--scrim-dialog);
  backdrop-filter: var(--blur-dialog);
  -webkit-backdrop-filter: var(--blur-dialog);
}
.dialog:focus-visible {
  outline: none;
  box-shadow: none;
}
.panel {
  display: flex;
  flex-direction: column;
  max-height: min(640px, 75dvh);
  border: var(--bw-hair) solid var(--border-hair);
  border-radius: var(--r-panel);
  background: var(--surface-card);
  box-shadow: var(--sh-xl);
  overflow: hidden;
}
.cabecera {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: var(--s-5);
  padding: var(--s-6);
  border-bottom: var(--bw-hair) solid var(--border-hair);
  color: var(--text-muted);
}
.cabecera:focus-within {
  border-bottom-color: var(--border-brand);
}
.campo {
  width: 100%;
  min-width: 0;
  padding: var(--s-2) 0;
  border: none;
  background: transparent;
  font-family: var(--font-body);
  font-size: 16px;
  color: var(--text-strong);
}
/* El foco lo dibuja la cabecera: el input no suma otro rectángulo. */
.campo:focus-visible {
  outline: none;
  box-shadow: none;
}
.campo::placeholder { color: var(--text-subtle); }
.cerrar {
  border: var(--bw-hair) solid var(--border-hair);
  border-radius: var(--r-badge);
  background: var(--surface-page);
  padding: var(--s-2) var(--s-3);
  font-family: var(--font-mono);
  font-size: var(--fs-2xs);
  color: var(--text-muted);
  cursor: pointer;
}
.lista {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: var(--s-3);
  scroll-padding: var(--s-3);
}
.grupo {
  padding: var(--s-5) var(--s-4) var(--s-3);
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  color: var(--text-subtle);
}
.fila {
  position: relative;
  isolation: isolate;
  display: flex;
  align-items: center;
  gap: var(--s-5);
  width: 100%;
  min-height: 44px;
  padding: var(--s-4);
  border: none;
  border-radius: var(--r-card);
  background: transparent;
  color: var(--text-body);
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  text-align: left;
  cursor: pointer;
}
.fila[aria-selected="true"] { color: var(--text-link); }
.activa {
  position: absolute;
  inset: 0;
  z-index: -1;
  border-radius: inherit;
  background: var(--surface-brand-faint);
}
.icono { display: flex; width: 18px; flex-shrink: 0; }
.label { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.badge { max-width: 30%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--text-subtle); font-size: var(--fs-2xs); }
.enter { color: var(--text-subtle); font-family: var(--font-mono); }
.estado { padding: var(--s-6); font-size: var(--fs-xs); color: var(--text-muted); text-align: center; }
.pie {
  flex-shrink: 0;
  display: flex;
  gap: var(--s-6);
  padding: var(--s-4) var(--s-6);
  border-top: var(--bw-hair) solid var(--border-hair);
  color: var(--text-subtle);
  font-size: var(--fs-2xs);
}
@media (max-width: 767px) {
  .dialog { margin-top: var(--s-6); }
  .panel { max-height: calc(100dvh - 2 * var(--s-6)); }
  .badge { display: none; }
}
